import { CompanyMealStateTypes, CompanyMealActionTypes } from "./CompanyMeal.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CompanyMealStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CompanyMealReducer = (
  state: CompanyMealStateTypes = INITIAL_STATE,
  action: any
): CompanyMealStateTypes => {
  switch (action.type) {
    case CompanyMealActionTypes.FETCH_ALL_COMPANY_MEAL:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CompanyMealActionTypes.FETCH_ALL_COMPANY_MEAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CompanyMealActionTypes.FETCH_ALL_COMPANY_MEAL_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CompanyMealActionTypes.FETCH_ALL_COMPANY_MEAL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CompanyMealActionTypes.FETCH_ONE_COMPANY_MEAL:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CompanyMealActionTypes.FETCH_ONE_COMPANY_MEAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CompanyMealActionTypes.FETCH_ONE_COMPANY_MEAL_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CompanyMealActionTypes.FETCH_ONE_COMPANY_MEAL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CompanyMealReducer;
